import React from "react";
import "./VerticalCalc.css";

function VerticalCalc({
                          dataMatrix = [],
                          title = "竖式计算",
                          charWidth = 30,
                          charHeight = 30,
                          fillAnswers = {},
                          currentBlankOrder = null, // 设为 null 避免默认选中，新增参数逻辑
                          onPlaceholderClick = () => {},
                          correctAnswers = [],
                          wrongAnswerRecords = [],
                          onWrongClick = () => {}
                      }) {
    const lineHeight = 20;
    const paddingX = 20;
    const paddingY = 20;

    let maxCols = 0;
    const rowHeights = dataMatrix.map(row => {
        if (typeof row === 'string' && row.toLowerCase() === 'line') {
            return lineHeight;
        }
        if (Array.isArray(row)) {
            maxCols = Math.max(maxCols, row.length);
            return charHeight;
        }
        return charHeight;
    });

    let cumulativeHeight = paddingY;
    const rowYPositions = dataMatrix.map(row => {
        const y = cumulativeHeight + (row === 'line' ? lineHeight / 2 : charHeight / 2);
        if (typeof row === 'string' && row.toLowerCase() === 'line') {
            cumulativeHeight += lineHeight;
        } else {
            cumulativeHeight += charHeight;
        }
        return y;
    });

    const svgWidth = maxCols * charWidth + 2 * paddingX;
    const svgHeight = cumulativeHeight + paddingY;

    const isPlaceholder = (str) => {
        return /^#\{\d+\}$/.test(str.trim());
    };

    const getPlaceholderId = (str) => {
        const match = str.match(/^#\{(\d+)\}$/);
        return match ? parseInt(match[1], 10) : null;
    };

    const isWrong = (blankOrder) => {
        return wrongAnswerRecords.some(record => record.blankOrder === blankOrder);
    };

    const getCorrectAnswer = (blankOrder) => {
        const answerObj = correctAnswers.find(ans => ans.blankOrder === blankOrder);
        return answerObj ? answerObj.answer : '';
    };

    const getWrongAnswer = (blankOrder) => {
        const answerObj = wrongAnswerRecords.find(ans => ans.blankOrder === blankOrder);
        return answerObj ? answerObj.answer : '';
    };

    const renderRowCells = (row, rowIndex, y) => {
        if (!Array.isArray(row)) return null;

        return row.map((cell, colIndex) => {
            if (!cell) return null;

            const x = paddingX + colIndex * charWidth + charWidth / 2;

            if (isPlaceholder(cell)) {
                const placeholderId = getPlaceholderId(cell);
                const isCurrent = placeholderId === currentBlankOrder;
                const userAnswer = fillAnswers[placeholderId] || "";
                const hasWrong = isWrong(placeholderId);
                const correctAnswer = getCorrectAnswer(placeholderId);
                const wrongAnswer = getWrongAnswer(placeholderId);
                const finalAnswer = hasWrong ? wrongAnswer : (userAnswer || correctAnswer); // 回答正确填上答案

                return (
                    <g key={`${rowIndex}-${colIndex}`}>
                        <rect
                            x={x - charWidth * 0.45}
                            y={y - charHeight * 0.5}
                            width={charWidth * 0.9}
                            height={charHeight * 0.9}
                            rx={6}
                            ry={6}
                            className={[
                                "calculate-grid-placeholder-rect",
                                isCurrent && wrongAnswerRecords.length === 0 ? "placeholder-active" : "", // 错题回放不显示默认选中
                                hasWrong ? "placeholder-wrong" : ""
                            ].join(" ")}
                            onClick={() => {
                                if (hasWrong) {
                                    onWrongClick(placeholderId);
                                } else {
                                    onPlaceholderClick(placeholderId);
                                }
                            }}
                        />
                        <foreignObject
                            x={x - charWidth * 0.5}
                            y={y - charHeight * 0.55}
                            width={charWidth}
                            height={charHeight}
                        >
                            <input
                                type="text"
                                className={[
                                    "calculate-grid-input",
                                    hasWrong ? "input-wrong" : ""
                                ].join(" ")}
                                value={finalAnswer}
                                readOnly
                                onClick={() => {
                                    if (hasWrong) {
                                        onWrongClick(placeholderId);
                                    } else {
                                        onPlaceholderClick(placeholderId);
                                    }
                                }}
                            />
                        </foreignObject>
                    </g>
                );
            } else {
                const isOperator = ["+", "-", "×", "÷"].includes(cell);
                return (
                    <text
                        key={`${rowIndex}-${colIndex}`}
                        x={x}
                        y={y}
                        className={`calculate-grid-text ${isOperator ? "calculate-grid-bold" : ""}`}
                    >
                        {cell}
                    </text>
                );
            }
        });
    };

    const renderLine = (rowIndex, y) => {
        return (
            <line
                key={`line-${rowIndex}`}
                className="calculate-grid-line"
                x1={paddingX}
                x2={svgWidth - paddingX}
                y1={y}
                y2={y}
            />
        );
    };

    return (
        <div className="calculate-grid-container">
            {title && <h2>{title}</h2>}
            <svg
                className="calculate-grid-svg"
                width={svgWidth}
                height={svgHeight}
                viewBox={`0 0 ${svgWidth} ${svgHeight}`}
            >
                {dataMatrix.map((row, rowIndex) => {
                    const y = rowYPositions[rowIndex];
                    if (typeof row === "string" && row.toLowerCase() === "line") {
                        return renderLine(rowIndex, y);
                    }
                    if (Array.isArray(row)) {
                        return (
                            <g key={`row-${rowIndex}`}>
                                {renderRowCells(row, rowIndex, y)}
                            </g>
                        );
                    }
                    return null;
                })}
            </svg>
        </div>
    );
}

export default VerticalCalc;